// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__bYMTY","summary":"CartItem_summary__9FW+Z","price":"CartItem_price__1qqca","amount":"CartItem_amount__GFryP","actions":"CartItem_actions__HegiR"};